import * as React from 'react';

/**
 * MUI icon for "AI" sparkle
 */
const SparkleIcon = ({ width = '16', height = '16' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path
      d="M6.79086 2.84536C6.94863 2.45894 7.49582 2.45895 7.65358 2.84536L8.50842 4.93912C8.98171 6.09834 9.90165 7.01829 11.0609 7.49157L13.1546 8.34641C13.541 8.50418 13.541 9.05137 13.1546 9.20913L11.0609 10.064C9.90165 10.5373 8.98171 11.4572 8.50842 12.6164L7.65358 14.7102C7.49582 15.0966 6.94863 15.0966 6.79086 14.7102L5.93602 12.6164C5.46274 11.4572 4.54279 10.5373 3.38357 10.064L1.28981 9.20913C0.903395 9.05137 0.903396 8.50418 1.28981 8.34641L3.38357 7.49157C4.54279 7.01828 5.46274 6.09834 5.93602 4.93911L6.79086 2.84536Z"
      fill="#1E2229"
    />
    <path
      d="M12.4081 1.17372C12.5027 0.942092 12.8307 0.942092 12.9253 1.17372L13.3286 2.16147C13.4231 2.3931 13.6069 2.57691 13.8386 2.67148L14.8263 3.07476C15.0579 3.16933 15.0579 3.49734 14.8263 3.59191L13.8386 3.99518C13.6069 4.08975 13.4231 4.27357 13.3286 4.50519L12.9253 5.49294C12.8307 5.72457 12.5027 5.72458 12.4081 5.49294L12.0049 4.50519C11.9103 4.27357 11.7265 4.08975 11.4948 3.99518L10.5071 3.59191C10.2755 3.49734 10.2755 3.16933 10.5071 3.07476L11.4948 2.67148C11.7265 2.57691 11.9103 2.3931 12.0049 2.16147L12.4081 1.17372Z"
      fill="#1E2229"
    />
  </svg>
);

export default SparkleIcon;
